<div class="modal-header">
    <h4 class="modal-title">Bordro {{ data.row ? 'Güncelle' : 'Ekle' }}</h4>
    <button type="button" class="close" (click)="closeModal()" aria-label="Close">
        <span aria-hidden="true">&times;</span>
    </button>
</div>

<div class="modal-body">
    <form [formGroup]="payrollForm">
        <div class="row">

            <!-- Maaş Ödeme Tarihi -->
            <div class="col-4">
                <label for="salaryPaymentDate">Maaş Ödeme Tarihi</label>
                <div class="form-group">
                    <ng2-flatpickr [config]="dateTimeStartOptions" name="dateTime" formControlName="salaryPaymentDate"
                        [setDate]="date"></ng2-flatpickr>
                </div>
            </div>

            <!-- F.M.-2 Saat -->
            <div class="col-4">
                <label for="fM2Hours">F.M.-2 Saat</label>
                <div class="form-group">
                    <input type="number" class="form-control" id="fM2Hours" formControlName="fM2Hours" />
                </div>
            </div>

            <!-- F.M.-3 Saat -->
            <div class="col-4">
                <label for="fM3Hours">F.M.-3 Saat</label>
                <div class="form-group">
                    <input type="number" class="form-control" id="fM3Hours" formControlName="fM3Hours" />
                </div>
            </div>

            <!-- F.M. Toplam Kazancı -->
            <div class="col-4">
                <label for="fmTotalEarnings">F.M. Toplam Kazancı</label>
                <div class="form-group">
                    <input type="number" class="form-control" id="fmTotalEarnings" formControlName="fmTotalEarnings" />
                </div>
            </div>

            <!-- EK-2 Kazancı -->
            <div class="col-4">
                <label for="eK2Earnings">EK-2 Kazancı</label>
                <div class="form-group">
                    <input type="number" class="form-control" id="eK2Earnings" formControlName="eK2Earnings" />
                </div>
            </div>

            <!-- Yol Para Yardımı -->
            <div class="col-4">
                <label for="transportationAllowance">Yol Para Yardımı</label>
                <div class="form-group">
                    <input type="number" class="form-control" id="transportationAllowance"
                        formControlName="transportationAllowance" />
                </div>
            </div>

            <!-- Toplam Gün -->
            <div class="col-4">
                <label for="totalDays">Toplam Gün</label>
                <div class="form-group">
                    <input type="number" class="form-control" id="totalDays" formControlName="totalDays" />
                </div>
            </div>

            <!-- Raporlu Gün -->
            <div class="col-4">
                <label for="sickLeaveDays">Raporlu Gün</label>
                <div class="form-group">
                    <input type="number" class="form-control" id="sickLeaveDays" formControlName="sickLeaveDays" />
                </div>
            </div>

            <!-- Ücretli Gün -->
            <div class="col-4">
                <label for="paidDays">Ücretli Gün</label>
                <div class="form-group">
                    <input type="number" class="form-control" id="paidDays" formControlName="paidDays" />
                </div>
            </div>

            <!-- Ücretsiz Gün -->
            <div class="col-4">
                <label for="unpaidDays">Ücretsiz Gün</label>
                <div class="form-group">
                    <input type="number" class="form-control" id="unpaidDays" formControlName="unpaidDays" />
                </div>
            </div>

            <!-- Yıllık İzin Gün -->
            <div class="col-4">
                <label for="annualLeaveDays">Yıllık İzin Gün</label>
                <div class="form-group">
                    <input type="number" class="form-control" id="annualLeaveDays" formControlName="annualLeaveDays" />
                </div>
            </div>

            <div class="col-4">
                <label for="grossSalary">Brüt Maaş</label>
                <div class="form-group">
                    <input type="number" class="form-control" id="grossSalary" formControlName="grossSalary" />
                </div>
            </div>
            <!-- Aylık Net Ödenen -->
            <div class="col-4">
                <label for="monthlyNetPaid">Aylık Net Ödenen</label>
                <div class="form-group">
                    <input type="number" class="form-control" id="monthlyNetPaid" formControlName="monthlyNetPaid" />
                </div>
            </div>

            <!-- İcra Kesintisi -->
            <div class="col-4">
                <label for="garnishmentDeduction">İcra Kesintisi</label>
                <div class="form-group">
                    <input type="number" class="form-control" id="garnishmentDeduction"
                        formControlName="garnishmentDeduction" />
                </div>
            </div>

            <!-- Avans Kesintisi -->
            <div class="col-4">
                <label for="advanceDeduction">Avans Kesintisi</label>
                <div class="form-group">
                    <input type="number" class="form-control" id="advanceDeduction"
                        formControlName="advanceDeduction" />
                </div>
            </div>

            <!-- BES Primi -->
            <div class="col-4">
                <label for="besContribution">BES Primi</label>
                <div class="form-group">
                    <input type="number" class="form-control" id="besContribution" formControlName="besContribution" />
                </div>
            </div>

            <!-- BES Sonrası Net Ödeme -->
            <div class="col-4">
                <label for="netAfterBes">BES Sonrası Net Ödeme</label>
                <div class="form-group">
                    <input type="number" class="form-control" id="netAfterBes" formControlName="netAfterBes" />
                </div>
            </div>

        </div>
    </form>
</div>

<div class="modal-footer">
    <button type="button" class="btn btn-danger" (click)="closeModal()">İptal</button>
    <button type="button" class="btn btn-success" [disabled]="!payrollForm.valid" (click)="onSumbit()">
        {{ data.row ? 'Güncelle' : 'Kaydet' }}
    </button>
</div>